<template>
  <div class="emptyData">
    <p><img src="/resource/images/img_holder_logo.png" alt="易乐玩盒子" /></p>
    <p><slot></slot></p>
  </div>
</template>

<script>
export default {
  name: 'EmptyData'
}
</script>

<style lang="less" scoped>
.emptyData {
  text-align: center;
  padding-top: 50px;
  color: #888;

  p{

    &:first-child{
      margin-bottom: 20px;
    }
  }
}
</style>
